var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UbiquityError } from './client.js';
var defaultOptions = {
    baseUrl: 'https://cloud.liquid-state.com/',
    baseS3Url: 'https://s3.ap-southeast-2.amazonaws.com/liquidstate-prod-apsoutheast2/',
};
var UbiquityAdmin = /** @class */ (function () {
    function UbiquityAdmin(identity, options) {
        var _this = this;
        this.identity = identity;
        this.addTagToDocument = function (app, documentId, tag) { return __awaiter(_this, void 0, void 0, function () {
            var body, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = new FormData();
                        body.append('term', tag);
                        body.append('label', tag);
                        return [4 /*yield*/, this.request("api/core/v1/apps/" + this.idFrom(app) + "/documents/" + documentId + "/metadata/tags/add/", 'POST', body)];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp.json()];
                }
            });
        }); };
        this.apps = function () { return __awaiter(_this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request('api/core/v1/apps/')];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp.json()];
                }
            });
        }); };
        this.appDetails = function (app) { return __awaiter(_this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("api/core/v1/apps/" + this.idFrom(app) + "/")];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp.json()];
                }
            });
        }); };
        this.createDocument = function (app, name, audienceType, metadata, ownerId) { return __awaiter(_this, void 0, void 0, function () {
            var body, resp, responseBody, versionList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = new FormData();
                        body.append('name', name);
                        body.append('audience_type', audienceType);
                        if (metadata) {
                            body.append('metadata', JSON.stringify(metadata));
                        }
                        if (ownerId) {
                            body.append('owner_id', ownerId);
                        }
                        return [4 /*yield*/, this.request("api/core/v1/apps/" + this.idFrom(app) + "/documents/", 'POST', body)];
                    case 1:
                        resp = _a.sent();
                        return [4 /*yield*/, resp.json()];
                    case 2:
                        responseBody = _a.sent();
                        _a.label = 3;
                    case 3:
                        if (!true) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.documentVersions(app, responseBody.id)];
                    case 4:
                        versionList = _a.sent();
                        if (versionList.length > 0 && versionList[0].is_ready) {
                            responseBody.latest_version = versionList[0];
                            return [3 /*break*/, 6];
                        }
                        return [4 /*yield*/, this.delay()];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 6: return [2 /*return*/, responseBody];
                }
            });
        }); };
        this.createDocumentVersion = function (app, documentId, versionData) { return __awaiter(_this, void 0, void 0, function () {
            var body, resp, respBody, versionInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = new FormData();
                        body.append('name', versionData.name);
                        body.append('description', versionData.description);
                        if (versionData.createFromVersion) {
                            body.append('create_from_version', versionData.createFromVersion);
                        }
                        if (versionData.creationMode) {
                            body.append('creation_mode', versionData.creationMode);
                        }
                        return [4 /*yield*/, this.request("api/core/v1/apps/" + this.idFrom(app) + "/documents/" + documentId + "/versions/", 'POST', body)];
                    case 1:
                        resp = _a.sent();
                        return [4 /*yield*/, resp.json()];
                    case 2:
                        respBody = _a.sent();
                        _a.label = 3;
                    case 3:
                        if (!true) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.documentVersion(app, documentId, respBody.id)];
                    case 4:
                        versionInfo = _a.sent();
                        if (versionInfo.is_ready)
                            return [3 /*break*/, 6];
                        return [4 /*yield*/, this.delay()];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 6: return [2 /*return*/, respBody];
                }
            });
        }); };
        this.deleteDocument = function (app, documentId) { return __awaiter(_this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("api/core/v1/apps/" + this.idFrom(app) + "/documents/" + documentId + "/", 'DELETE')];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp];
                }
            });
        }); };
        this.document = function (app, documentId) { return __awaiter(_this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("api/core/v1/apps/" + this.idFrom(app) + "/documents/" + documentId + "/")];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp.json()];
                }
            });
        }); };
        this.documents = function (app, queryStringParameters) { return __awaiter(_this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("api/core/v1/apps/" + this.idFrom(app) + "/documents/" + (queryStringParameters
                            ? "?" + Object.keys(queryStringParameters).reduce(function (queryString, key) { return "" + queryString + key + "=" + queryStringParameters[key] + "&"; }, '')
                            : ''))];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp.json()];
                }
            });
        }); };
        this.documentPublishedStatus = function (app, document) { return __awaiter(_this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/api/core/v1/apps/" + this.idFrom(app) + "/documents/" + this.idFrom(document) + "/channels/Public/")];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp.json()];
                }
            });
        }); };
        this.documentVersions = function (app, document) { return __awaiter(_this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "api/core/v1/apps/" + this.idFrom(app) + "/documents/" + this.idFrom(document) + "/versions/";
                        return [4 /*yield*/, this.request(url)];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.documentVersion = function (app, document, version) { return __awaiter(_this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("api/core/v1/apps/" + this.idFrom(app) + "/documents/" + this.idFrom(document) + "/versions/" + this.idFrom(version) + "/")];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp.json()];
                }
            });
        }); };
        this.documentLatestVersionPublicDetails = function (app, documentProductId) { return __awaiter(_this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("api/core/v1/apps/" + this.idFrom(app) + "/documents/" + this.idFrom(documentProductId) + "/")];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp.json()];
                }
            });
        }); };
        this.editDocument = function (app, documentId, name, metadata, ownerId) { return __awaiter(_this, void 0, void 0, function () {
            var body, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = new FormData();
                        body.append('name', name);
                        if (metadata) {
                            body.append('metadata', JSON.stringify(metadata));
                        }
                        if (ownerId) {
                            body.append('owner_id', ownerId);
                        }
                        return [4 /*yield*/, this.request("api/core/v1/apps/" + this.idFrom(app) + "/documents/" + documentId + "/", 'POST', body)];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp.json()];
                }
            });
        }); };
        this.editDocumentVersion = function (app, documentId, versionId, editData) { return __awaiter(_this, void 0, void 0, function () {
            var body, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = new FormData();
                        if (editData.name) {
                            body.append('name', editData.name);
                        }
                        if (editData.description) {
                            body.append('description', editData.description);
                        }
                        if (editData.displayName) {
                            body.append('display_name', editData.displayName);
                        }
                        return [4 /*yield*/, this.request("api/core/v1/apps/" + this.idFrom(app) + "/documents/" + documentId + "/versions/" + versionId + "/configuration/", 'POST', body)];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.exportUploadDone = function (app, importId) { return __awaiter(_this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("api/importing/v1/apps/" + this.idFrom(app) + "/isues/import/" + importId + "/status/", 'POST')];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp.json()];
                }
            });
        }); };
        this.pages = function (documentOrDocumentVersion) { return __awaiter(_this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if ('pages' in documentOrDocumentVersion.links) {
                            url = documentOrDocumentVersion.links.pages;
                        }
                        else {
                            url = documentOrDocumentVersion.links.page_list;
                        }
                        return [4 /*yield*/, this.request(url)];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        }); };
        this.appendOptionalFormData = function (obj, optionalKeys, form) {
            if (form === void 0) { form = new FormData(); }
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    optionalKeys.forEach(function (_a) {
                        var objKey = _a.objKey, formKey = _a.formKey;
                        if (obj[objKey]) {
                            form.append(formKey, obj[objKey]);
                        }
                    });
                    return [2 /*return*/];
                });
            });
        };
        this.getDocumentUploadUrl = function (app, documentId, versionId, uploadUrlData) { return __awaiter(_this, void 0, void 0, function () {
            var body, resp, respBody;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = new FormData();
                        body.append('import_file_name', uploadUrlData.fileName);
                        this.appendOptionalFormData(uploadUrlData, [
                            { objKey: 'importAtPosition', formKey: 'import_at_position' },
                            { objKey: 'importType', formKey: 'import_type' },
                        ], body);
                        return [4 /*yield*/, this.request("/api/importing/v1/apps/" + this.idFrom(app) + "/documents/" + documentId + "/versions/" + versionId + "/imports/", 'POST', body)];
                    case 1:
                        resp = _a.sent();
                        return [4 /*yield*/, resp.json()];
                    case 2:
                        respBody = _a.sent();
                        return [2 /*return*/, {
                                importSessionId: respBody.id,
                                uploadUrl: respBody.upload_url,
                            }];
                }
            });
        }); };
        this.putDocument = function (uploadUrl, file) { return __awaiter(_this, void 0, void 0, function () {
            var body, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = new FormData();
                        body.append('file', file);
                        return [4 /*yield*/, fetch(uploadUrl, {
                                headers: {
                                    'Content-Type': 'application/pdf',
                                },
                                method: 'PUT',
                                body: body,
                            })];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp];
                }
            });
        }); };
        this.removeTagFromDocument = function (app, documentId, tag) { return __awaiter(_this, void 0, void 0, function () {
            var body, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = new FormData();
                        body.append('term', tag);
                        body.append('label', tag);
                        return [4 /*yield*/, this.request("api/core/v1/apps/" + this.idFrom(app) + "/documents/" + documentId + "/metadata/tags/remove/", 'POST', body)];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp.json()];
                }
            });
        }); };
        this.documentVersionUploadStatus = function (app, documentId, versionId, importId) { return __awaiter(_this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("api/importing/v1/apps/" + this.idFrom(app) + "/documents/" + documentId + "/versions/" + versionId + "/imports/" + importId + "/", 'GET')];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp.json()];
                }
            });
        }); };
        this.uploadDocumentVersion = function (app, documentId, versionId, uploadUrlData, file) { return __awaiter(_this, void 0, void 0, function () {
            var _a, importSessionId, uploadUrl, resp, uploadDoneResp, statusResp;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (uploadUrlData.fileName.length > 30) {
                            uploadUrlData.fileName = uploadUrlData.fileName.slice(0, 26) + ".pdf";
                        }
                        return [4 /*yield*/, this.getDocumentUploadUrl(app, documentId, versionId, uploadUrlData)];
                    case 1:
                        _a = _b.sent(), importSessionId = _a.importSessionId, uploadUrl = _a.uploadUrl;
                        return [4 /*yield*/, this.putDocument(uploadUrl, file)];
                    case 2:
                        resp = _b.sent();
                        return [4 /*yield*/, this.documentVersionUploadAcknowledged(app, documentId, versionId, importSessionId)];
                    case 3:
                        uploadDoneResp = _b.sent();
                        _b.label = 4;
                    case 4:
                        if (!true) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.documentVersionUploadStatus(app, documentId, versionId, importSessionId)];
                    case 5:
                        statusResp = _b.sent();
                        if (statusResp.status === 'completed' || statusResp.status === 'failed') {
                            return [3 /*break*/, 7];
                        }
                        return [4 /*yield*/, this.delay()];
                    case 6:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 7: return [2 /*return*/, { importSessionId: importSessionId, resp: resp }];
                }
            });
        }); };
        this.documentVersionUploadAcknowledged = function (app, documentId, versionId, importId) { return __awaiter(_this, void 0, void 0, function () {
            var body, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = new FormData();
                        body.append('status', 'upload_acknowledged');
                        return [4 /*yield*/, this.request("/api/importing/v1/apps/" + this.idFrom(app) + "/documents/" + documentId + "/versions/" + versionId + "/imports/" + importId + "/", 'PATCH', 'status=upload_acknowledged')];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp];
                }
            });
        }); };
        this.publish = function (app, documentId, versionId) { return __awaiter(_this, void 0, void 0, function () {
            var initalPublishDetailsList, publishingDetails, publishingDetailsList, publishingRecord, isPublishing, statusBody;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.publishingDetails(app, documentId)];
                    case 1:
                        initalPublishDetailsList = _a.sent();
                        return [4 /*yield*/, this.publishDocument(app, documentId, versionId)];
                    case 2:
                        _a.sent();
                        publishingDetails = null;
                        _a.label = 3;
                    case 3:
                        if (!!publishingDetails) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.publishingDetails(app, documentId)];
                    case 4:
                        publishingDetailsList = _a.sent();
                        if (publishingDetailsList.length > initalPublishDetailsList.length) {
                            publishingDetails = publishingDetailsList;
                        }
                        return [4 /*yield*/, this.delay()];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 6:
                        publishingRecord = publishingDetails.find(function (_a) {
                            var version = _a.version;
                            return version.id == "" + versionId;
                        }).id;
                        isPublishing = true;
                        _a.label = 7;
                    case 7:
                        if (!isPublishing) return [3 /*break*/, 10];
                        return [4 /*yield*/, this.publishingStatus(app, documentId, publishingRecord)];
                    case 8:
                        statusBody = _a.sent();
                        switch (statusBody.publishing_record.status) {
                            case 'successful':
                                isPublishing = false;
                                break;
                            case 'failed':
                                isPublishing = false;
                                throw UbiquityError('Failed to publish document', statusBody);
                            default:
                                return [3 /*break*/, 7];
                        }
                        return [4 /*yield*/, this.delay()];
                    case 9:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 10: return [2 /*return*/];
                }
            });
        }); };
        this.publishingDetails = function (app, documentId) { return __awaiter(_this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/api/publishing/v1/apps/" + this.idFrom(app) + "/documents/" + documentId + "/channels/Public/published/")];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp.json()];
                }
            });
        }); };
        this.publishDocument = function (app, documentId, versionId) { return __awaiter(_this, void 0, void 0, function () {
            var body, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = new FormData();
                        body.append('version_id', "" + versionId);
                        return [4 /*yield*/, this.request("/api/publishing/v1/apps/" + this.idFrom(app) + "/documents/" + documentId + "/channels/Public/published/", 'POST', body)];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp];
                }
            });
        }); };
        this.publishingStatus = function (app, documentId, publishingRecord) { return __awaiter(_this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/api/publishing/v1/apps/" + this.idFrom(app) + "/documents/" + documentId + "/channels/Public/published/" + publishingRecord + "/")];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp.json()];
                }
            });
        }); };
        this.setDocumentAvailability = function (app, documentId, availability) { return __awaiter(_this, void 0, void 0, function () {
            var body, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = new FormData();
                        body.append('availability', availability);
                        return [4 /*yield*/, this.request("/api/core/v1/apps/" + this.idFrom(app) + "/documents/" + documentId + "/channels/Public/", 'POST', body)];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp];
                }
            });
        }); };
        this.delay = function (ms) {
            if (ms === void 0) { ms = 200; }
            return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) { return setTimeout(function () { return resolve(); }, ms); })];
            }); });
        };
        this.request = function (path, method, body, headers) {
            if (method === void 0) { method = 'GET'; }
            return __awaiter(_this, void 0, void 0, function () {
                var auth, resp;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            auth = this.identity.apiKey
                                ? "Token " + this.identity.apiKey
                                : "Bearer " + this.identity.jwt;
                            return [4 /*yield*/, fetch("" + this.options.baseUrl + this.cleanPath(path), __assign({ headers: __assign({ Authorization: auth }, (headers ? headers : {})), method: method }, (body ? { body: body } : {})))];
                        case 1:
                            resp = _a.sent();
                            if (!resp.ok) {
                                throw new Error('Invalid ubiquity request');
                            }
                            return [2 /*return*/, resp];
                    }
                });
            });
        };
        this.idFrom = function (id) {
            if (id.id) {
                return id.id.toString();
            }
            return id.toString();
        };
        this.cleanPath = function (path) {
            var final = path;
            while (final.startsWith('/')) {
                final = final.slice(1);
            }
            return final;
        };
        if (!options) {
            this.options = defaultOptions;
        }
        this.options = __assign(__assign({}, defaultOptions), options);
        if (!this.options.baseUrl) {
            this.options.baseUrl = defaultOptions.baseUrl;
        }
        if (!this.options.baseS3Url) {
            this.options.baseS3Url = defaultOptions.baseS3Url;
        }
    }
    return UbiquityAdmin;
}());
export default UbiquityAdmin;
//# sourceMappingURL=admin-client.js.map